export enum Icons {
  ARROW_TOP = 'icons:arrow-top',
  FLANGE = 'icons:flange',
  PIPE = 'icons:pipe',
  STEAM_TRAP = 'icons:steamtrap',
  ROTATING = 'icons:rotatingEqu',
  STEAM_TRAP_SMALL = 'icons:steamtrap-small-icon',
  HELP = 'icons:help-round',
  REPAIR_INSTRUCTION = 'assets/images/repair_instructions_2.png',
  REPAIR_INSTRUCTION2 = 'assets/images/repair_instructions_3.png',
  STAT_EXPLANATION_OCTAGON = 'icons:status-exclamation-octagon',
  STAT_EXPLANATION_TRIANGLE = 'icons:status-exclamation-triangle',
  STAT_WORKING_FINE = 'icons:working-fine',
  CROSS_CIRCLE = 'icons:cross-circle',
  STATUS_CHECK = 'icons:status-check',
  DISCONNECTED = 'icons:disconnected',
}

export enum Images {
  FLANGE_IMG = 'assets/images/default_equipments/Flange.png',
  PIPE_IMG = 'assets/images/default_equipments/Pipe.png',
  STEAMTRAP_IMG = 'assets/images/default_equipments/Steamtrap.png',
  TANK_IMG = 'assets/images/default_equipments/Tank.png',
  VALVE_IMG = 'assets/images/default_equipments/Valve.png',
  ROTATING_CENTRIFUGE = 'assets/images/Loctite-pulse-smart-Centrifuge.png',
  ROTATING_COMPRESSOR = 'assets/images/Loctite-pulse-smart-Compressorr.png',
  ROTATING_MOTOR = 'assets/images/Loctite-pulse-smart-Motor.png',
  ROTATING_FAN = 'assets/images/Loctite-pulse-smart-Fan.png',
  ROTATING_PUMP = 'assets/images/Loctite-pulse-smart-Pump.png',
  ROTATING_OTHER = 'assets/images/rotating_other.png',
  DEFAULT_ROTATING = 'assets/images/default_equipments/rotatingEqu.png',
  DEFAULT_SENSOR_IMG = 'assets/images/default_sensor.png',
  ROTATING_GEAR_BOX = 'assets/images/Loctite-pulse-smart-Gear-box.png',
  DEFAULT_PLANT_IMG = 'assets/images/plant_default_picture.png',
  SENSOR_PHOTO_INSTRUCTION = 'assets/images/sensor_photo_instruction.png',
  SENSOR_QR_INSTRUCTION_NEW = 'assets/images/sensor_qr_instruction_new.png',
  SENSOR_QR_INSTRUCTION_2 = 'assets/images/sensor_qr_instruction_2.png',
  JUNCTION_BOX_INSTRUCTION_1 = 'assets/images/junction_box_instruction_1.png',
  JUNCTION_BOX_INSTRUCTION_2 = 'assets/images/junction_box_instruction_2.png',
  SENSOR_QR_INSTRUCTION_NEW_2 = 'assets/images/sensor_qr_instruction_new_2.jpg',
  CONNECTION_ERROR = 'assets/images/connection_error.png',
  GATEWAY_MATRIX_1 = 'assets/images/sensor_gateway_matrix_1.png',
  GATEWAY_MATRIX_2 = 'assets/images/sensor_gateway_matrix_2.png',
  INLET_SENSOR_QR_INS_1 = 'assets/images/inlet_sensor_qr_instruction_1.png',
  INLET_SENSOR_QR_INS_2 = 'assets/images/inlet_sensor_qr_instruction_2.png',
  INLET_SENSOR_QR_INS_3 = 'assets/images/inlet_sensor_qr_instruction_3.png',
  SENSOR_QR_INSTRUCTION_DAU1 = 'assets/images/sensor_qr_instruction_dau_1.png',
  SENSOR_QR_INSTRUCTION_DAU2 = 'assets/images/sensor_qr_instruction_dau_2.png',
  HTST_DAU_IMG = 'assets/images/htst_dau_image.png',
  REPAIR_INSTRUCTION = 'assets/images/repair_instructions_2.png',
  REPAIR_INSTRUCTION2 = 'assets/images/repair_instructions_3.png',
}
